import { Grid, Input } from '@material-ui/core';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOrgTemplateFindById from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateFindById';
import { Weight } from '@opsbase/web-app/theme';
import useCss from '@opsbase/web-css';
import DataChooser from '@opsbase/web-data-choosers/DataChooser';
import PlaceChooser from '@opsbase/web-data-choosers/PlaceChooser';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import Card from '@opsbase/web-layout/Card';
import Vertical from '@opsbase/web-layout/Vertical';
import OpTypePicker from '@opsbase/web-pickers/OpTypePicker';
import Button from '@opsbase/web-ui/Button';
import Switch from '@opsbase/web-ui/Switch';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
const makeMyClasses = () => ({
    input: {
        fontSize: 16,
        fontWeight: Weight.Heavy,
        lineHeight: '22px',
    },
});
export function OpDefinitionCreateConfigurationSetting(props) {
    const { item, onChangeTitle, onChangePlace, onChangeTeamsPositions, onChangeOpType, onChangeEnabled, onChangeScoreEnabled, onSelectAllTeamsPositions, onRemove, type, disableRemove = false } = props;
    const myCss = useCss(makeMyClasses);
    const { data } = useOrgTemplateFindById({
        variables: { id: item.id },
        skip: type !== 'orgtemplate',
    });
    const fullItem = {
        ...(data ? JSON.parse(JSON.stringify(data)) : {}),
        ...(item ? JSON.parse(JSON.stringify(item)) : {}),
    };
    return (React.createElement(Card, null,
        React.createElement(Grid, { container: true, style: { flexDirection: 'row', width: '100%' } },
            React.createElement(Grid, { item: true, xs: 11, style: { padding: 10 } },
                React.createElement(Input, { classes: {
                        root: 'OBHideLine',
                        input: myCss.input,
                    }, fullWidth: true, onChange: onChangeTitle, value: fullItem.title }),
                React.createElement(Text, null, fullItem.description)),
            React.createElement(Grid, { item: true, xs: 1, style: { padding: 10 } },
                React.createElement(Grid, { container: true, style: {
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        width: '100%',
                    } }, !disableRemove && (React.createElement(Grid, { item: true, style: { marginRight: -10 } },
                    React.createElement(Button, { color: Palette.White, onClick: onRemove, icon: React.createElement(DeleteIcon, null), small: true })))))),
        React.createElement(Grid, { container: true, alignItems: "center", style: { flexDirection: 'row', width: '100%' } },
            React.createElement(Grid, { item: true, xs: 6, style: { padding: 10 } },
                React.createElement(Text, null, i18n.t('select-where-op-to-perform')),
                React.createElement(PlaceChooser, { multi: true, required: true, value: fullItem['places'], onChange: onChangePlace })),
            React.createElement(Grid, { item: true, xs: 6, style: { padding: 10 } },
                React.createElement(Text, null, i18n.t('select-who-op-to-perform')),
                React.createElement(DataChooser, { disabled: fullItem['lockEditingOfOpDefinition'], multi: true, required: true, value: [...(fullItem.teams || []), ...(fullItem.positions || [])], type: [DataType.POSITION, DataType.TEAM], onChange: onChangeTeamsPositions, allSelectable: true, allSelected: fullItem.allPTsPermitted, allSelectedLabel: i18n.t('all-teams-positions'), onSelectAll: onSelectAllTeamsPositions }))),
        React.createElement(Grid, { container: true, alignItems: "center", style: { flexDirection: 'row', width: '100%' } },
            React.createElement(Grid, { item: true, xs: 6, style: { padding: 10 } },
                React.createElement(Text, { variant: 'h3' }, i18n.t('op-type-description')),
                React.createElement(OpTypePicker, { disabled: fullItem['lockEditingOfOpDefinition'], fullWidth: true, noMargin: true, white: true, value: fullItem.type, onChange: onChangeOpType })),
            React.createElement(Grid, { item: true, xs: 6, style: { padding: 10 } },
                React.createElement(Vertical, { gutter: true },
                    React.createElement(Switch, { checked: fullItem.enabled, onChange: onChangeEnabled, label: i18n.t('enable-op-plan-immediate') }),
                    React.createElement(Switch, { disabled: fullItem['lockEditingOfOpDefinition'], checked: fullItem.isScoreEnabled, onChange: onChangeScoreEnabled, label: i18n.t('will-this-op-be-scored'), tip: i18n.t('scoring-help-desc') }))))));
}
export default OpDefinitionCreateConfigurationSetting;
